import { useQuery } from 'react-query';
import { useAxiosClient } from '../utils/useAxiosClient';

export interface DateRange {
  start_date: string;
  end_date: string | null;
}

export interface Brand {
  id: string;
  name: string;
}

export interface Platform {
  id: string;
  name: string;
}

export interface FilterSetData {
  org_name: string;
  date_range: DateRange;
  brands: Brand[];
  platforms: Platform[];
  pillars: {
    pillars: string[];
  };
  dashboard_type: string;
  dei_target_pillar?: string;
}

export const useFilterSetData = (orgId: number, options?: { enabled?: boolean }) => {
  const axiosClient = useAxiosClient();

  const { data, isLoading, error } = useQuery(
    ['filterSetData', orgId],
    async () => {
      if (!orgId) {
        throw new Error('No organization selected');
      }
      
      const response = await axiosClient.get(`/api/filterset?org=${orgId}`);
      return response.data as FilterSetData;
    },
    {
      enabled: !!orgId && (options?.enabled !== false),
      staleTime: 30 * 60 * 1000, // 30 minutes - this data rarely changes
      retry: 1,
      refetchOnWindowFocus: false
    }
  );

  return {
    filterSetData: data,
    loading: isLoading,
    error: error ? (error instanceof Error ? error.message : 'An error occurred') : null
  };
}; 